import { DIRECTIONS } from 'components/Chevron';
import {
  COLLECTION_COLORWAY_PICKER_ITEM_TYPES as COLORWAY_PICKER_ITEM_TYPES,
  COLLECTION_COLORWAY_PICKER_APPEARANCES as COLORWAY_PICKER_APPEARANCES,
} from 'constants/collectionPage';

const NAV_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
};

export { DIRECTIONS, COLORWAY_PICKER_ITEM_TYPES, COLORWAY_PICKER_APPEARANCES, NAV_SIZES };
